import firebase from 'firebase/compat/app';

export class StripeCustomer {
  uid: string;
  id: string;
  created: firebase.firestore.Timestamp;
  modified: firebase.firestore.Timestamp;
}
